<template>
  <v-layout justify-center column class="container mt-4 mb-4">
    <v-form
      ref="form"
      @submit.prevent="submit"
      align-center
      justify-center
      lazy-validation
      class="mt-4 pb-4"
    >
      <v-card class="set-password-form">
        <h1 class="headline justify-center">
          {{ $t('setPassword.title') }}
        </h1>
        <v-container :class='{ "pt-4": $vuetify.breakpoint.xs }'>
          <v-card-text>
            <v-container grid-list-md class="px-0 pb-0" :class='{ "px-0": $vuetify.breakpoint.xs }'>

              <!-- Password -->
              <v-layout row>
                <v-flex sm12 >
                  <v-text-field
                    name='password'
                    :label='$t("common.fields.password") + "*"'
                    v-model='setData.password'
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules='rules.password'
                    @click:append="showPassword = !showPassword"
                    required />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex sm12 >
                  <v-text-field
                    name='repeatPassword'
                    :label='$t("common.fields.password.repeat") + "*"'
                    v-model='setData.passwordConfirmation'
                    :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPasswordConfirmation ? 'text' : 'password'"
                    :rules='rules.repeatPassword'
                    @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                    required />
                </v-flex>
              </v-layout>

              <!-- Alerts -->
              <v-alert
                class='auth-alert mb-3 text-sm-center'
                :value="successAlert.state"
                type="success"
              >
                {{ successAlert.msg }}
              </v-alert>

              <v-alert class='auth-alert mb-3' :value="errorAlert.state" type="error">
                {{ errorAlert.msg }}
              </v-alert>

            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout align-center class="btns-wrapper">
              <v-btn
                type='submit'
                :disabled="areBtnsDisabled"
                color='warning mt-2'
                large
                depressed>
              {{ $t('common.btns.setPassword') }}
            </v-btn>
            </v-layout>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-form>
  </v-layout>

</template>

<script>
export default {
  name: 'SetPasswordPage',
  data() {
    return {
      setData: {
        token: null,
        email: null,
        password: '',
        passwordConfirmation: '',
      },
      showPassword: false,
      showPasswordConfirmation: false,
      rules: {
        password: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) => /^[a-zа-яA-ZА-Я0-9!@#$%^&*)(+=._-]{8,}$/.test(v) || this.$t('common.fields.validation.password'),
        ],
        repeatPassword: [(val) => val === this.setData.password || this.$t('common.fields.validation.password.dontMatch')],
      },
      errorAlert: {
        state: false,
        msg: '',
      },
      successAlert: {
        state: false,
        msg: '',
      },
      areBtnsDisabled: false,
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.areBtnsDisabled = true;
        const response = await this.$store.dispatch('auth/setPassword', this.setData);

        if (response.data.success) {
          this.$refs.form.reset();
          this.errorAlert.state = false;
          this.errorAlert.msg = '';
          this.successAlert.state = true;
          this.successAlert.msg = response.data.data.message;

          setTimeout(() => {
            this.areBtnsDisabled = false;
            this.$router.push({ name: 'login' });
          }, 2000);
        } else {
          this.successAlert.state = false;
          this.successAlert.msg = '';
          this.errorAlert.state = true;
          this.areBtnsDisabled = false;
          this.errorAlert.msg = response.data.error.message;
        }
      }
    },
  },
  created() {
    this.setData.token = this.$route.params.hash;
    this.setData.email = this.$route.query.email;
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.set-password-form {
  max-width: 500px;
  margin: 0 auto;
  margin-top: 70px;
  padding: 0 50px;

  @media (max-width: 599px) {
    margin-top: 35px;;
  }

  .headline {
    text-align: center;
    font-weight:700;
    font-size: 30px !important;
    padding-top: 50px;
    padding-bottom: 10px;
    color: #FF8A1F;
  }

  .btns-wrapper {
    justify-content: space-around;
    a {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
    button {
      margin-bottom: 34px;
    }
  }
}
</style>
